import moment from 'moment'

export const range = n => Array.from(Array(n).keys())
export const title = string => string.charAt(0).toUpperCase() + string.slice(1)
export const getGenderName = id => ['Pojke', 'Flicka'][id]
export const humanDate = x => moment(x).format('LLL')
export const timeAgo = x => moment(x).calendar()
export const strictlyIncreasing = x => x[x.length - 1] - x[0] === x.length - 1

export const unique = (a, keyFunc) => {
  const keys = a.map(keyFunc)
  return a.filter((elem, pos) => keys.indexOf(keyFunc(elem)) === pos)
}

export const isoWeekdayNamePlural = n =>
  [
    'Måndagar',
    'Tisdagar',
    'Onsdagar',
    'Torsdagar',
    'Fredagar',
    'Lördagar',
    'Söndagar',
  ][n]

export const fbq = (...args) =>
  typeof window !== 'undefined' && window.fbq && window.fbq(...args)

export default {
  range,
  title,
  unique,
}



// WEBPACK FOOTER //
// ../source/utilities/index.js